module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALJJREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9LINBTj+D++oAbG8eAMahYqh+AFoE8/EqOQ0jhOgKZuGC4gViO1g/oCvSwGJaKD5GgcsOw0avGoxaMWgyoHfWLEaOHjCUCL4pEsnQ+kAugV1LBisgBaXtMljguQqj0BaPk8gS4NAWicHoC2rRyIrQqpAkCWAzH/aEN90AOAAAMAoGQsw9U8jbUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/5.png
// module id = 760
// module chunks = 0